// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"2143":"app","4736":"vendor"}[chunkId] || chunkId) + "." + {"2143":"a7d5ecd8","4736":"28bb81f8","5969":"c1dcd932"}[chunkId] + ".css";
};